export * from './input-picture.component';
export * from './input-picture.utils';
